// extracted by mini-css-extract-plugin
export default {"main":"e1afe8c4cc","tit":"_4e3e1363ca","maintitle":"_112fe3f19f","ylw":"d23573110c","white":"bd2870ec1b","mv_title":"c89e18c58f","mv_nc":"cb32861956","mv_in":"e64fd605c5"};